import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { ModalDismissReasons, NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { Subscription } from 'rxjs';
import { applicationPaths, localStorageKeys, screenDetails } from '../../../../Models/configurations';
import { AppsettingService } from '../../../../Services/appsetting.service';
import { CheckInDataService } from '../../../../Services/check-in-data.service';
import { progressStepNames } from './../../../../Models/progress-bar-step';
import { SecureStorageService } from './../../../../Services/secure-storage.service';
import { UtilityServices } from './../../../../Services/utility.services';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';
import { GlobalSetting } from 'projects/Autofacets-Core/src/app/common-services/global-setting.service';
import { CurrentLanguage } from 'projects/Autofacets-Core/src/app/common-services/current-language.service';

@Component({
  selector: 'app-fourth-step',
  templateUrl: './fourth-step.component.html',
  //styleUrls: ['./fourth-step.component.css']
})
export class FourthStepComponent implements OnInit, OnDestroy  {
  urlName: string;
  title = 'appBootstrap';
  modelName = 'mymodal';
  closeResult: string;
  serviceList: [];
  showFixList = false;
  private modalRef: NgbModalRef;
  public steps: any;
  public activeStepName: string;
  public activeStepCompleted: boolean;
  public serviceAdditionalDetail: any = {
    additionalDetail: ''
  };
  public serviceListPlans: any;
  isServiceAlreadyExist: boolean = false;
  documentSignUrl: string = "";
  warrantySigned: boolean = false;
  isLoadService:boolean = false;
  private readonly globalValueSubscription: Subscription

  constructor(
    private readonly modalService: NgbModal,
    private readonly utilityService: UtilityServices,
    private readonly appsettingService: AppsettingService,
    private readonly secureStorageService: SecureStorageService,
    private readonly cdrf: ChangeDetectorRef,
    private readonly checkInDataService: CheckInDataService,
    private readonly spinner: NgxSpinnerService,
    private readonly toaster: ToastrService,
    private readonly translate: TranslateService,
    private readonly globalSetting: GlobalSetting,
    private readonly currentLanguageService: CurrentLanguage,
  ) {
    if (this.secureStorageService.getKeyData(localStorageKeys.stepStatus) !== undefined) {
      this.steps = this.secureStorageService.getKeyData(localStorageKeys.stepStatus);
    }
    this.globalValueSubscription = this.globalSetting.warrantyDocumentSigned?.subscribe((value) => {
      this.warrantySigned = value;
    });
  }
  ngOnDestroy() {
    // Clean up subscription
    if (this.globalValueSubscription) {
      this.globalValueSubscription.unsubscribe();
    }
  }
  additionalInfo(content) {
    this.modalRef = this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title' });
    this.modalRef.result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  private getServiceList(): void {
    let servicePlans = this.secureStorageService.getKeyData(localStorageKeys.cdkRepairData);
    if(servicePlans == null)
    {
      this.serviceList = [];
      this.serviceAdditionalDetail = {
        additionalDetail: ''
      };
    }
    else{
      this.serviceList = servicePlans.servicePlanList;
      this.serviceAdditionalDetail = {
        additionalDetail: this.secureStorageService.getKeyData(localStorageKeys.cdkRepairData).additionalInformation
      };
      this.serviceListPlans = {
        servicePlanList: this.secureStorageService.getKeyData(localStorageKeys.cdkRepairData).ServicePlanList
      }
    }
    this.secureStorageService.setKeyData(localStorageKeys.additionalDetails, this.serviceAdditionalDetail);
    this.secureStorageService.setKeyData(localStorageKeys.servicePlanDetails, this.serviceListPlans);
  }

  private saveAdditionalDetails(additionalDetails: string) {
    if (!additionalDetails || additionalDetails.trim() == "") {
      this.secureStorageService.removeKey(localStorageKeys.additionalDetails);
      let errorMsg = this.translate.instant("lblPleaseAddValidComment");
      this.toaster.error(errorMsg);
    }
    else{
      this.serviceAdditionalDetail = {
        additionalDetail: additionalDetails
      };
      this.secureStorageService.removeKey(localStorageKeys.additionalDetails);
      this.secureStorageService.setKeyData(localStorageKeys.additionalDetails, this.serviceAdditionalDetail);
      this.modalRef.close();
    }
  }

  public moveNext(): void {
    this.urlName = this.appsettingService.getScreenConfiguration(screenDetails.stepFour);
    this.activeStepCompleted = true;
    this.activeStepName = progressStepNames.stepName2;
    this.appsettingService.stepCompletion(this.activeStepName, this.activeStepCompleted);
    this.steps = this.secureStorageService.getKeyData(localStorageKeys.stepStatus);
    this.cdrf.detectChanges();
    this.utilityService.navigateToNext(this.urlName);
  }

  ngOnInit(): void {
    this.OnInitlize();
  }

  async OnInitlize(){
    await this.checkInDataService.GetCheckInModuleData().subscribe(data => {
      if(data){
        if(data['isCheckInNotAllowed'])
        {
          this.spinner.hide();
          this.utilityService.navigateToNext('/' + applicationPaths.seven);
        }
        else{
          this.GetDocumentSignUrl();
          if (this.secureStorageService.getKeyData(localStorageKeys.cdkRepairData) !== undefined) {
            this.getServiceList();
            this.isServiceAlreadyExist = true;
          }
          else if (this.checkInDataService.cdkRepairDetails) {
            this.checkInDataService.cdkRepairDetails.asObservable().subscribe(_x => {
              this.getServiceList();
            });
          }
          this.isLoadService = true;
          this.cdrf.detectChanges();
        }
      }
    });
  }

  GetDocumentSignUrl(){
    const checkInData = this.secureStorageService.getKeyData(localStorageKeys.checkingModule);
    if (checkInData) {
      this.spinner.show();
      this.checkInDataService.GetDocumentSignUrl().subscribe(
        (res: any) => {
          this.spinner.hide();
          if ( res?.success) {
            this.documentSignUrl = res?.documentUrl;
          }
        },
        (_err) =>{
          this.spinner.hide();
        },
        () =>{
          this.spinner.hide();
        }
      );
    }
  }
  GetWarrantyDocumentStatus(){
    const checkInData = this.secureStorageService.getKeyData(localStorageKeys.checkingModule);
    if (checkInData) {
    let model = {
      LanguageCode: this.currentLanguageService.currentLanguage.value,
      AppointmentId: 0,
      AppointmentGuid: this.secureStorageService.getKeyData(localStorageKeys.checkingModule).appointmentGuid,
      WorkOrderNo: this.secureStorageService.getKeyData(localStorageKeys.checkingModule).workOrderId,
      DealerId: this.secureStorageService.getKeyData(localStorageKeys.checkingModule)?.dealerDetail?.dealerId,
      IsSend: true,
      MakeName: this.secureStorageService.getKeyData(localStorageKeys.checkingModule).vehicleDetail.companyMake
    };
    this.spinner.show();
    this.checkInDataService.SendWarrantyDocument(model).then(
      (res: any) => {
        if (res && res.responseCode == 2) {
          // intentially
          this.globalSetting.warrantyDocumentSigned.next(true);
          this.globalSetting.warrantyDocumentSigned?.subscribe((value) => {
            this.warrantySigned = value;
          });
        }
        else{
          this.toaster.warning(this.translate.instant("lblSignOnWarrantyDocument"));
        }
      }, (_err) => {
        let error = this.translate.instant("lblPdfGenerateError");
        this.toaster.error(error);
      },).finally(() => {
        this.spinner.hide();
      });
    }
  }
}
